import {
  Dialog,
  Box,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SvgTulip } from "../../svgs/tulipwhite.svg";
import BubbleContainer from "./components/BubblesContainer";

const BubbleExperienceModal = ({ open, onClose }) => {
  const [activeSolution, setActiveSolution] = useState("generalManufactoring");

  const solutions = [
    { label: "General Manufacturing", id: "generalManufactoring" },
    { label: "Life Sciences", id: "lifeScience" },
  ];

  const handleToggleChange = (event, newValue) => {
    if (newValue !== null) {
      setActiveSolution(newValue);
    }
  };

  // Find the selected solution object
  const selectedSolution = solutions.find((sol) => sol.id === activeSolution);

  return (
    <Dialog
      className="solutions_Bubbles"
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          color: "#fff",
          background: "#00263E",
        },
      }}
    >
      {/* Header */}
      <Box className="flex justify-between items-center p-4">
        <div className="flex items-center gap-14">
          <SvgIcon
            inheritViewBox
            sx={{ height: "45px", width: "auto", color: "customColors.white" }}
            component={SvgTulip}
          />

          {/* Toggle Button Group */}
          <Box className="flex items-center gap-4">
            <Typography className="messina_light" variant="body1" sx={{ color: "#fff" }}>
              Solutions for:
            </Typography>
            <ToggleButtonGroup
              className="h-10 messina relative z-[2] toggle-btn-group"
              value={activeSolution}
              exclusive
              onChange={handleToggleChange}>
              {solutions.map((sol) => (
                <ToggleButton key={sol.id} value={sol.id}>
                  {sol.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </div>
        <IconButton className="relative z-[2] -top-3 -right-3" onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content Area */}
      <Grid container className="w-full px-4">
        <BubbleContainer id={selectedSolution.id} />
      </Grid>
    </Dialog>
  );
};

export default BubbleExperienceModal;
